"use client";

// packages/eden-headings/src/components/H1.jsx
import styled from "styled-components";
import { mediaBreak600w } from "@churchofjesuschrist/eden-styled-helpers";
import { jsx } from "react/jsx-runtime";
var H1Styled = styled.h1`
  margin: 0;
  font: normal normal 700 calc(32rem / 16) / 1.2 var(--unity-font-family-sans);
  ${(props) => props.$small ? "" : mediaBreak600w`font-size: calc(42rem / 16);`};

  ${({ $formal }) => $formal ? "font-family: var(--unity-font-family-serif);font-weight: 400;" : ""}
`;
var H1 = ({ small, children, renderAs, formal, ...props }) => /* @__PURE__ */ jsx(H1Styled, { $small: small, as: renderAs, $formal: formal, ...props, children });
H1.displayName = "H1";
var H1_default = H1;
export {
  H1_default as default
};
